import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: to => {
      return { path: '/sellout/file' }
    }
  },
  {
    path: '/sellout/:type',
    name: 'manual',
    component: () => import('../components/Sellout.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login.vue'),
    props: true 
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  //base: "/nuovo/area-riservata/",
  routes: routes
})

export default router